
import "./ProductList.css";
import { Link } from "react-router-dom";
import ProductCard from "../product/ProductCard";

const ProductList = ({ products }) => (
  <div className="product-grid">
    {products.map((p) => (
      <Link
        key={p._id}
        to={`/product/${p._id}`}
        className="text-decoration-none text-dark"
      >
        <ProductCard
          image={`${p.images?.[0]}`}
          title={p.title}
          price={p.price}
          rating={4.5}
        />
      </Link>
    ))}
  </div>
);
export default ProductList;
{
  /* <div className="card h-100">
            <img src={p.image} className="card-img-top" alt={p.title}/>
            <div className="card-body">
              <h6 className="card-title">{p.title}</h6>
            </div>
            <div className="card-footer">
              <span className="fw-bold">${p.price}</span>
            </div>
          </div> */
}
// const ProductList = ({ products }) => {
//   return (
//     <div className="container py-4">
//       <h2 className="mb-4">Products</h2>
//       <div className="row">
//         {products.map((product) => (
//           <div key={product.id} className="col-sm-6 col-md-3 mb-4">
//             <Link
//               to={`/product/${product.id}`}
//               className="text-decoration-none text-dark"
//             >
//               <div className="card">
//                 <img
//                   src={product.image}
//                   className="card-img-top"
//                   alt={product.title}
//                 />
//                 <div className="card-body">
//                   <h5 className="card-title">{product.title}</h5>
//                   <p className="card-text">${product.price}</p>
//                 </div>
//               </div>
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };
// export default ProductList;
// const ProductList = ({ products }) => {
//   return (
//     <div className="d-flex flex-wrap gap-4 p-4 justify-content-center">
//       {products.map((item) => (
//         <ProductCard
//           key={item.id}
//           image={item.image}
//           title={item.title}
//           price={item.price}
//           onAddToCart={() => alert(`Added ${item.title} to cart`)}
//         />
//       ))}
//     </div>
//   );
// };

// export default ProductList;
